import { Account } from './account';
import { CertificateModel } from './certificate.model';

export enum WebsocketEventType {
  Certificate = 0,
  AccountCreated = 13,
  AccountUpdated = 14,
  AccountInfoUpdated = 20,
  AccountSwapFree = 29,
  AccountBalance = 30,
  AccountLeverage = 31,
  PrimaryAccountUpdated = 42
}

export interface AccountInfo {
  id: number;
  comment: string;
  name: string;
}

export class WebsocketEvent<T> {
  response: T;
  eventType: WebsocketEventType;
}

export class AccountCreatedEvent {
  account: Account;
}

export class AccountUpdatedEvent {
  account: Account;
}

export class AccountInfoUpdatedEvent {
  accountInfoUpdated: AccountInfo;
}

export interface AccountBalanceEvent {
  balance: {
    AccountId: number;
    login: number;
    currency: string;
    balance: number;
    credit: number;
    equity: number;
    margin: number;
  };
}

export interface AccountLeverageEvent {
  leverage: {
    AccountId: number,
    leverage: number
  };
}

export interface AccountSwapFreeEvent {
  swapFree: {
    AccountId: number,
    isSwapFree: boolean
  };
}

export interface PrimaryAccount {
  primaryAccount: {
    primaryAccountId: number
  }
}

export interface CertificateEvent {
  certificate: CertificateModel;
}
